<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="パケットフィルタリング契約参照"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <!-- 契約or解約ボタン -->
            <div class="d-flex flex-row justify-end mb-2">
              <v-btn
                color="primary"
                v-permission.admin
                @click="contractReference"
                >{{
                  contractGetPacketFiltering.packetFilterEnabled
                    ? "解約"
                    : "契約"
                }}</v-btn
              >
            </div>
            <!-- パケットフィルタリング契約 -->
            <v-row>
              <v-col>
                <app-label-group
                  label="パケットフィルタリング契約"
                  :value="
                    $filter.enumTo(
                      contractGetPacketFiltering.packetFilterEnabled,
                      'contractStatus'
                    )
                  "
                />
                <span
                  class="ml-3 attention"
                  v-if="contractGetPacketFiltering.packetFilterEnabled"
                  >※ルール数が1個以上存在する場合、パケットフィルタリング契約を変更できません。</span
                >
              </v-col>
            </v-row>
            <!-- ルール数 -->
            <v-row>
              <v-col>
                <app-badge
                  item="ルール数"
                  :isRequired="false"
                  :msg="$filter.message('info_packet_filtering_rule')"
                />
                <div class="ml-3">
                  {{ contractGetPacketFiltering.packetFilterRuleCount }} 個
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>
        <v-alert v-if="alertMsg" class="mb-4" :text="alertMsg" />
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import packetFilteringContractConfirm from "@/modals/packetFiltering/PacketFilteringContractConfirm.vue";
import type { ContractGetPacketFiltering } from "@/apis/PacketFilteringApi";

export default defineComponent({
  name: "PacketFilteringContractReference",
  data() {
    return {
      alertMsg: null as string | null,
      /** 初期通信完了フラグ */
      isLoaded: false,
      contractGetPacketFiltering: {} as ContractGetPacketFiltering,
    };
  },
  async mounted() {
    await this.load();
    this.isLoaded = true;
  },
  methods: {
    /** データ取得 */
    async load() {
      this.contractGetPacketFiltering =
        await this.$api.packetFilter.getContractPacketFiltering();
    },
    /** 契約変更確認画面を表示 */
    async contractReference() {
      if (this.contractGetPacketFiltering.packetFilterRuleCount !== 0) {
        this.alertMsg = this.$filter.message("packet_filtering_rule_count");
      } else {
        // 確認モーダルを表示
        await this.$modal.show(packetFilteringContractConfirm, {
          contractGetPacketFiltering: this.contractGetPacketFiltering,
        });
        // 情報更新
        await this.$api.packetFilter.postContractPacketFiltering({
          contractPacketFilterKeyId:
            this.contractGetPacketFiltering.contractPacketFilterKeyId,
          packetFilterEnabled:
            !this.contractGetPacketFiltering.packetFilterEnabled,
          note: null,
        });
        // 契約情報が変更されるためサマリー情報を再取得してvuexのデータを更新
        await this.$store.dispatch("user/updateLoginInfo", {
          contractSummary: await this.$api.contract.getSummary(),
        });
        (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
      }
    },
  },
});
</script>

<style lang="scss" scoped>
// 注意文言のサイズ変更、改行しないことが目的のため可能な限り大きく表示
.attention {
  font-size: 99%;
}
</style>
